import { render, staticRenderFns } from "./accountConfiguration.vue?vue&type=template&id=682cb812&"
import script from "./accountConfiguration.vue?vue&type=script&lang=js&"
export * from "./accountConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports